module.exports = __webpack_public_path__ + "img/DinersClub.a8a0f05e.svg";